import React from "react";
import { Typography } from "@material-ui/core";

export const ContactField: React.FC<{
  label: string;
  value: string | null;
}> = ({ label, value }) => (
  <>
    <Typography variant="caption">{label}</Typography>
    <Typography variant="subtitle1">{value || ""}</Typography>
  </>
);
export type ContactInfo = {
  dateOfBirthDt: string | null;
  phoneNumber: string | null;
  email: string | null;
};
